<template>
  <v-content pa-0>
    <Header></Header>
    <div
      style="position: relative;display: flex;justify-content: center;align-items: center"
      :style="$vuetify.breakpoint.mdAndUp ? {'padding-top': '88px'}:{}"
    >
     
    </div>
    <v-container>
      <v-layout justify-center my-10 >
        <v-flex xs11 sm10 md12 >
          <img :src="require('../assets/not-found.png')" width="150" />
          <h1 style="font-size: 48px">Page not found</h1>
          <p style="font-size: 24px">The requested page couldn't be located. Checkout for any URL misspelling or <a class="txt-link" href="/">return to the home page</a></p>
        </v-flex>
      </v-layout>
    </v-container>
    <Footer></Footer>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  
  name: "Page404",
  components: {
    Header,
    Footer
  },
  data: () => ({

  }),
  created() {
    // this.$router.replace('/');
  }
};
</script>
